module.exports = __webpack_public_path__ + "img/album12_07.d3350ccd.jpg";